"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bakersfieldFilmFestival = void 0;
const types_1 = require("../types");
const fizz_1 = require("./fizz");
const hearthHarmony_1 = require("./hearthHarmony");
exports.bakersfieldFilmFestival = Object.assign(Object.assign({}, fizz_1.fizz), { meta: {
        title: "Bakersfield Film Festival Events",
        description: "Take part of Bakersfield Film Festival-sponsored events in your community!",
        image: (0, types_1.getFileUrl)("/bakersfield-film-festival/tags/logo512.png"),
        icon: (0, types_1.getFileUrl)("/bakersfield-film-festival/tags/favicon.ico"),
    }, company: {
        name: "Bakersfield Film Festival",
        logo: {
            url: (0, types_1.getFileUrl)("/bakersfield-film-festival/logo.svg"),
            description: "bakersfield film festival",
            style: {
                height: 30,
                width: "auto",
            },
            versions: {
                white: { url: (0, types_1.getFileUrl)("/bakersfield-film-festival/logo-white.svg") },
            },
        },
    }, event: hearthHarmony_1.hearthHarmony.event, footerLinks: [
        {
            text: "Bakersfield Film Festival Privacy Policy",
            url: "https://www.max.live/privacy-policy",
        },
        { text: "MAX Privacy Policy", url: "https://www.max.live/privacy-policy" },
    ], fanAppUrl: `https://bakersfieldfilm.live`, artistAppUrl: `https://dashboard.bakersfieldfilm.live`, regionsCollection: "bakersfield_film_festival_regions" });
